import React from 'react';
import { ChartPie } from '@phosphor-icons/react';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';

const tooltipStyle = {
  backgroundColor: 'hsl(var(--card))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '0.25rem',
};

const SegmentationTab = ({ segmentation }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-card border border-border rounded-sm p-6">
        <div className="flex items-center mb-6">
          <ChartPie size={24} weight="regular" className="mr-3" />
          <div>
            <div className="text-xl font-semibold tracking-tight">By Industry</div>
            <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">REVENUE BREAKDOWN</div>
          </div>
        </div>
        {segmentation?.by_industry?.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={segmentation.by_industry}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="category" stroke="hsl(var(--foreground))" style={{ fontSize: '12px' }} />
              <YAxis stroke="hsl(var(--foreground))" style={{ fontSize: '12px' }} />
              <Tooltip contentStyle={tooltipStyle} />
              <Bar dataKey="revenue" fill="hsl(var(--accent))" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-64 flex items-center justify-center text-muted-foreground">No industry data yet</div>
        )}
      </div>

      <div className="bg-card border border-border rounded-sm p-6">
        <div className="flex items-center mb-6">
          <ChartPie size={24} weight="regular" className="mr-3" />
          <div>
            <div className="text-xl font-semibold tracking-tight">By Region</div>
            <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">REVENUE BREAKDOWN</div>
          </div>
        </div>
        {segmentation?.by_region?.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={segmentation.by_region}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="category" stroke="hsl(var(--foreground))" style={{ fontSize: '12px' }} />
              <YAxis stroke="hsl(var(--foreground))" style={{ fontSize: '12px' }} />
              <Tooltip contentStyle={tooltipStyle} />
              <Bar dataKey="revenue" fill="hsl(var(--primary))" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-64 flex items-center justify-center text-muted-foreground">No region data yet</div>
        )}
      </div>
    </div>

    <div className="bg-card border border-border rounded-sm p-6">
      <div className="text-xl font-semibold tracking-tight mb-4">Segmentation Summary</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-bold tracking-[0.2em] uppercase text-muted-foreground mb-3">Industry Breakdown</h3>
          <div className="space-y-2">
            {segmentation?.by_industry?.map((item) => (
              <div key={item.category} className="flex justify-between items-center py-2 border-b border-border">
                <span className="font-medium">{item.category}</span>
                <div className="text-right">
                  <div className="font-semibold">₹{item.revenue.toLocaleString()}</div>
                  <div className="text-xs text-muted-foreground">{item.clients} clients</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <h3 className="text-sm font-bold tracking-[0.2em] uppercase text-muted-foreground mb-3">Region Breakdown</h3>
          <div className="space-y-2">
            {segmentation?.by_region?.map((item) => (
              <div key={item.category} className="flex justify-between items-center py-2 border-b border-border">
                <span className="font-medium">{item.category}</span>
                <div className="text-right">
                  <div className="font-semibold">₹{item.revenue.toLocaleString()}</div>
                  <div className="text-xs text-muted-foreground">{item.clients} clients</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SegmentationTab;
